<div class="modal-header modal-padding"
     data-cy="consent-modal-header"
>
  <button aria-label="Close"
          class="close"
          data-cy="consent-modal-close-button"
          data-dismiss="modal"
          type="button"
  >
      <span [innerHTML]="'x'"
            (click)="close(false)"
            aria-hidden="true"
            data-cy="consent-modal-close-text"
      ></span>
  </button>
</div>
<div class="modal-body modal-padding"
     data-cy="consent-modal-body"
>
  <mb-uc-blocked-content-replacer [ucId]="ucId"
                                  [ucService]="ucService"
                                  [ucServiceId]="ucServiceId"
                                  (isAccepted)="close(true)"
  ></mb-uc-blocked-content-replacer>
</div>
<div class="modal-footer"
     data-cy="consent-modal-footer"
></div>

